"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _colors = _interopRequireDefault(require("../../colors"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireWildcard(require("./Button.styled"));

var _excluded = ["text", "type", "navigateUrl", "forceExternalLink", "target", "isCompact", "fillContainer", "icon", "primaryColor", "buttonStyle", "onDarkBg", "disabled", "onButtonClick", "buttonID", "automationId", "className", "linkComponent"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var text = _ref.text,
      type = _ref.type,
      navigateUrl = _ref.navigateUrl,
      _ref$forceExternalLin = _ref.forceExternalLink,
      forceExternalLink = _ref$forceExternalLin === void 0 ? false : _ref$forceExternalLin,
      target = _ref.target,
      _ref$isCompact = _ref.isCompact,
      isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
      fillContainer = _ref.fillContainer,
      icon = _ref.icon,
      _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? _colors["default"].primary.claytonBlue : _ref$primaryColor,
      _ref$buttonStyle = _ref.buttonStyle,
      buttonStyle = _ref$buttonStyle === void 0 ? '' : _ref$buttonStyle,
      _ref$onDarkBg = _ref.onDarkBg,
      onDarkBg = _ref$onDarkBg === void 0 ? false : _ref$onDarkBg,
      disabled = _ref.disabled,
      onButtonClick = _ref.onButtonClick,
      buttonID = _ref.buttonID,
      automationId = _ref.automationId,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      linkComponent = _ref.linkComponent,
      props = _objectWithoutProperties(_ref, _excluded);

  var inverseStyles = ['shadow', 'outlined'];
  var propertyClasses = [];
  (0, _react.useEffect)(function () {
    if (!automationId) {
      console.warn('Automation id was not provided.');
    }
  }, [automationId]);
  propertyClasses.push(primaryColor.className);
  propertyClasses.push(buttonStyle);

  if (inverseStyles.indexOf(buttonStyle) > -1) {
    propertyClasses.push('inverse');
  }

  if (isCompact) {
    propertyClasses.push('compact');
  }

  if (onDarkBg) {
    propertyClasses.push('on-dark');
  }

  if (disabled) {
    propertyClasses.push('disabled');
  }

  if (fillContainer) {
    propertyClasses.push('fill-container');
  }

  if (navigateUrl) {
    if (navigateUrl.indexOf('http://') === 0 || navigateUrl.indexOf('https://') === 0 || target == '_blank' || forceExternalLink) {
      return /*#__PURE__*/_react["default"].createElement(_Button.ExternalLinkButtonStyles, {
        className: className + ' ' + propertyClasses.join(' '),
        href: navigateUrl,
        target: navigateUrl ? target || '_blank' : '',
        rel: "noreferrer noopener",
        id: buttonID,
        "data-test-id": automationId,
        onClick: onButtonClick,
        type: type
      }, icon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "icon"
      }, icon), text || props.children) : text || props.children);
    } else {
      return /*#__PURE__*/_react["default"].createElement(_Button.InternalLinkButtonStyles, {
        as: linkComponent,
        className: className + ' ' + propertyClasses.join(' '),
        rel: "noreferrer noopener",
        id: buttonID,
        "data-test-id": automationId,
        onClick: onButtonClick,
        to: navigateUrl,
        type: type
      }, icon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "icon"
      }, icon), text || props.children) : text || props.children);
    }
  } else {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
      className: className + ' ' + propertyClasses.join(' '),
      id: buttonID,
      "data-test-id": automationId,
      onClick: onButtonClick,
      type: type
    }, props), icon ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "icon"
    }, icon), text || props.children) : text || props.children);
  }
};

var _default = Button;
exports["default"] = _default;
Button.propTypes = {
  buttonStyle: _propTypes["default"].oneOf(['', 'solid', 'shadow', 'outlined']),
  target: _propTypes["default"].string,
  isCompact: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  fillContainer: _propTypes["default"].bool,
  icon: _propTypes["default"].object,
  primaryColor: _propTypes["default"].oneOf([_colors["default"].primary.claytonBlue, _colors["default"].secondary.kiddiePool, _colors["default"].secondary.summerNight, _colors["default"].accent.ladyBug, _colors["default"].accent.cheesePuff, _colors["default"].secondary.rubberDucky, _colors["default"].accent.darkBlue, _colors["default"].primary.white, _colors["default"].accent.claytonGreen, _colors["default"].primary.black]),
  disabled: _propTypes["default"].bool,
  onButtonClick: _propTypes["default"].any,
  buttonID: _propTypes["default"].string,
  automationId: _propTypes["default"].string,
  linkComponent: _propTypes["default"].object,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  navigateUrl: _propTypes["default"].string,
  className: _propTypes["default"].string,
  type: _propTypes["default"].any,
  forceExternalLink: _propTypes["default"].bool,
  onDarkBg: _propTypes["default"].bool
};
Button.defaultProps = {
  buttonStyle: '',
  isCompact: false,
  target: '',
  fillContainer: false,
  primaryColor: _colors["default"].primary.claytonBlue,
  disabled: false
};